import sectionCardReviewCss from '../css-snippets/section-card-review';

const html = ` 
<style>${sectionCardReviewCss}</style>
<div
  class="card-review-wrapper"
  data-id="unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div class="card-review-container container" data-position="left">
    <div class="card-review-left">
      <div class="card-review-image">
        <img
          src="https://cdn.skyfastimg.com/images/2025/12/15/image-693f738eaa0f583515e54c89.avif?w=50&h=50&q=80"
          alt="image"
        />
      </div>
      <div class="card-review-text-container">
        <div class="card-review-text">
          <p style="text-align: center;">
            "Bought this for my cat... ended up being obsessed with it myself! The
            way it scurries and those glowing eyes are hypnotic. Endless fun and
            way tougher than it looks!"
          </p>
        </div>
        <div class="card-review-name">Caius W.</div>
        <div class="card-review-verified">
          <svg
            data-v-79f52826=""
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="card-review-verified-icon"
          >
            <path
              data-v-79f52826=""
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
            ></path>
          </svg>
          <div class="card-review-verified-text">Verified Buyer</div>
        </div>
      </div>
    </div>
    <div class="card-review-right">
      <div data-full-stars="5" class="card-review-wrap-stars">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="0"
          height="0"
          style="position: absolute"
        >
          <defs>
            <linearGradient
              id="half-star-gradient-infinite"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
            >
              <stop offset="50%" style="stop-color: #f0b100; stop-opacity: 1" />
              <stop offset="50%" style="stop-color: #f0b100; stop-opacity: 0" />
            </linearGradient>
          </defs>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
        </svg>
      </div>
      <div class="card-review-content">
        <h2>
          <strong>6. Loved by over 15,000 Families</strong>
        </h2>
        <p>
          From curious kids to fun-seeking adults, tens of thousands are
          thrilled by the Electric Lizard with LED Glowing Eyes - an incredible
          toy that scuttles automatically with lifelike movement, changes
          direction unpredictably, and delights with its glowing gaze and
          surprise factor every time it's turned on.
        </p>
      </div>
      <div class="card-review-list">
        <div class="card-review-item">
          <div class="card-review-item-image">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/15/image-693f73aca5a1015333082eb0.avif?w=50&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="card-review-item-text">
            <p>
            <strong>Lifelike Scuttling & Auto Steering</strong>
            </p>
          </div>
        </div>
        <div class="card-review-item">
          <div class="card-review-item-image">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/15/image-693f73bec6360038d84885d2.avif?w=50&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="card-review-item-text">
            <p>
              <strong>Attention-Grabbing LED Glowing Eyes</strong>
            </p>
          </div>
        </div>
        <div class="card-review-item">
          <div class="card-review-item-image">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/15/image-693f73ce37f1bfafd9480904.avif?w=50&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="card-review-item-text">
            <p>
              <strong>Durable & Shockproof & Kid-and-Pet-Friendly</strong>
            </p>
          </div>
        </div>
      </div>
      <div class="card-review-footer">
        <p>* Results based on a survey of 4,925 customers.</p>
      </div>
    </div>
  </div>
</div>
`;

export default html;
